import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { CONST_CONFIG } from '@/config'

interface MapUiState {
  hydrated: boolean
  currentBasemap: string
  userSelectedBasemap: string | null
  basemapSwitcherVisible: boolean
  setHydrated: (hydrated: boolean) => void
  setCurrentBasemap: (basemap: string) => void
  setUserSelectedBasemap: (basemap: string) => void
  resetBasemapToTheme: (basemap: string) => void
  setBasemapSwitcherVisible: (visible: boolean) => void
}

export const useMapUiStore = create<MapUiState>()(
  persist(
    (set) => ({
      hydrated: false,
      currentBasemap: CONST_CONFIG.BASEMAP,
      userSelectedBasemap: null,
      basemapSwitcherVisible: false,
      setHydrated: (hydrated) => set({ hydrated }),
      setCurrentBasemap: (currentBasemap) => set({ currentBasemap }),
      setUserSelectedBasemap: (basemap) => set({
        currentBasemap: basemap,
        userSelectedBasemap: basemap,
      }),
      resetBasemapToTheme: (basemap) => set({
        currentBasemap: basemap,
        userSelectedBasemap: null,
      }),
      setBasemapSwitcherVisible: (basemapSwitcherVisible) => set({ basemapSwitcherVisible }),
    }),
    {
      name: 'map-ui-storage',
      // 旧版本可能持久化了 ArcGIS 默认底图；升级后先回到 Ignite，
      // 避免无 API key 的旧底图覆盖新的服务器底图配置。
      version: 1,
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true)
      },
      partialize: (state) => (state.userSelectedBasemap
        ? {
            currentBasemap: state.currentBasemap,
            userSelectedBasemap: state.userSelectedBasemap,
          }
        : {
            userSelectedBasemap: null,
          }),
    }
  )
)
